import moment from "moment";

Date.prototype.toJSON = function () {
    return moment(this).format();
}

export function cloneObject(object) {
    if (object == undefined) {
        return { };
    }

    return JSON.parse(JSON.stringify(object));;
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/functions/object.ts